import { render, staticRenderFns } from "./PubgAccount.vue?vue&type=template&id=89cc7090&scoped=true"
import script from "./PubgAccount.vue?vue&type=script&lang=js"
export * from "./PubgAccount.vue?vue&type=script&lang=js"
import style0 from "./PubgAccount.vue?vue&type=style&index=0&id=89cc7090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cc7090",
  null
  
)

export default component.exports